import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MuiModule } from '@move/ui';
import { TranslateModule } from '@ngx-translate/core';
import { MmuMaintenanceBannerComponent } from './mmu-maintenance-banner/mmu-maintenance-banner.component';


@NgModule({
  declarations: [MmuMaintenanceBannerComponent],
  exports: [
    MmuMaintenanceBannerComponent
  ],
  imports: [
    CommonModule,
    MuiModule,
    TranslateModule,
    HttpClientModule
  ]
})
export class MmuMaintenanceModule {}
